import { pick } from 'ramda';
import { withProps } from 'recompose';
import { useDeviceSelector } from 'js/store/hooks';
import useScreenSize, { SCREEN_SIZES } from 'js/hooks/useScreenSize';
import { COMPETITORS_VS_PRIZES_VIEW, PRIZES_VIEW, COMPETITORS_VS_PRIZES_POSITION } from './constants';
import style from './index.scss';

export default withProps(
    (props) => {
        const {
            details,
            displayPrizes,
            displayTable,
            competitorsTablePositioning
        } = props;

        const { rules, termsAndConditionsUrl } = details;
        const { isTablet, isDesktop } = useDeviceSelector(pick(['isTablet', 'isDesktop']));
        const { callbackRef: detailsRef, screenSize } = useScreenSize({
            narrow: isDesktop ? null : 600,
            middle: 900
        });

        const isNarrow = screenSize === SCREEN_SIZES.narrow;
        const isMiddle = screenSize === SCREEN_SIZES.middle;
        const isSmallScreen = isTablet || isNarrow || isMiddle;

        const positioning = isSmallScreen || !displayPrizes || !displayTable
            ? COMPETITORS_VS_PRIZES_POSITION.horizontal
            : competitorsTablePositioning;

        const footerLayout = termsAndConditionsUrl ? style.footerRow : style.onlyLeaveBtn;

        const containerClassName = [
            style[COMPETITORS_VS_PRIZES_VIEW[positioning]],
            isSmallScreen && style.middleScreen,
            isNarrow && style.narrowScreen,
            !isNarrow && footerLayout
        ].filter(Boolean).join(' ');

        return {
            detailsRef,
            containerClassName,
            prizesView: PRIZES_VIEW[positioning],
            raceInfoView: rules || isNarrow ? 'column' : 'row'
        };
    }
);
